module.exports = __webpack_public_path__ + "static/rust-c493e3d7b259487ec9621c043a0fbf2f.mp4";